<template>
  <div>
    <portal to="body-end">
      <b-sidebar
          id="sidebar-add-new-event"
          sidebar-class="sidebar-xl"
          v-model="sidebar.visible"
          bg-variant="white"
          shadow
          backdrop
          no-header
          width="1200px"
          right
          @change="(val) => $emit('update:is-event-handler-sidebar-active', val)"
      >
        <!-- Header -->
        <div class="crs-header">
          <div class="d-flex align-items-center" style="gap:10px">
            <div class="crs-header-icon"><i class="fas fa-file-contract"></i></div>
            <div v-if="loading == null && contractId != null">
              <div class="crs-header-title">{{ contract.client.firstname }} {{ contract.client.lastname }}</div>
              <div class="crs-header-sub">{{ contract.moveDate | moment('DD/MM/YY') }} &middot; {{ property.address }}</div>
            </div>
            <div v-else>
              <div class="crs-header-title">{{ msg('Loading') }}...</div>
            </div>
          </div>
          <div class="d-flex align-items-center" style="gap:8px">
            <a :href="`/real_estate/contracts/rent/${contractId}`" target="_blank" class="crs-link-btn" v-b-tooltip :title="msg('Open in new tab')">
              <i class="fa-solid fa-arrow-up-right-from-square"></i>
            </a>
            <b-button variant="light" size="sm" class="crs-close-btn" @click="sidebar.visible = false">
              <i class="fas fa-times"></i>
            </b-button>
          </div>
        </div>

        <!-- Content -->
        <div v-if="loading==null && contractId != null" class="crs-body">
          <b-tabs v-model="tabsIndex" align="center" nav-class="crs-tabs-nav">
            <!-- Contract Tab -->
            <b-tab :title="msg('Contract')" active>
              <div v-if="contract != null" class="crs-tab-content">
                <div class="crs-info-table">
                  <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-tag mr-50"></i> Id</span><span class="crs-info-val">{{ contract.id }}</span></div>
                  <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-tag mr-50"></i> External Id</span><span class="crs-info-val">{{ contract.hostawayReservationId }}</span></div>
                  <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-calendar-day mr-50"></i> {{ msg("Register date") }}</span><span class="crs-info-val">{{ $moment(contract.creationTime).format("DD/MM/yy HH:mm") }}</span></div>
                  <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-user mr-50"></i> {{ msg("Client") }}</span><span class="crs-info-val text-capitalize">{{ contract.client.firstname }} {{ contract.client.lastname }} <span v-if="contract.client.birthday != null">({{ $moment().diff(contract.client.birthday, 'years') }})</span></span></div>
                  <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-home mr-50"></i> {{ msg("Property") }}</span><span class="crs-info-val">{{ property.address }} {{ property.house }}, {{ property.city }}, {{ property.country }}</span></div>
                  <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-clipboard mr-50"></i> {{ msg("Usage") }}</span><span class="crs-info-val">{{ contract.use }}</span></div>
                  <div class="crs-info-row" v-if="contract.bnbStyleRent!=null&&contract.bnbStyleRent.active"><span class="crs-info-key"><i class="fas fa-globe mr-50"></i> {{ msg("Platform") }}</span><span class="crs-info-val">{{ contract.bnbStyleRent.platform }}</span></div>
                  <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-user-tie mr-50"></i> {{ msg("Landlord Firstname") }}</span><span class="crs-info-val">{{ contract.landlord.firstname }}</span></div>
                  <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-user-tie mr-50"></i> {{ msg("Landlord Lastname") }}</span><span class="crs-info-val">{{ contract.landlord.lastname }}</span></div>
                  <div class="crs-info-row" v-if="contract.bnbStyleRent!=null&&contract.bnbStyleRent.active"><span class="crs-info-key"><i class="fas fa-money-check-alt mr-50"></i> {{ msg("Period price") }}</span><span class="crs-info-val"><strong>{{ contract.bnbStyleRent.totalPayment }} &euro;</strong></span></div>
                  <div class="crs-info-row" v-if="contract.bnbStyleRent!=null&&contract.bnbStyleRent.active"><span class="crs-info-key"><i class="fas fa-money-check-alt mr-50"></i> {{ msg("periodpriceafterdis") }}</span><span class="crs-info-val">{{ contract.bnbStyleRent.totalPaymentDiscount }} &euro;</span></div>
                  <div class="crs-info-row" v-if="contract.bnbStyleRent!=null&&contract.bnbStyleRent.active"><span class="crs-info-key"><i class="fas fa-moon mr-50"></i> {{ msg("TotalNights") }}</span><span class="crs-info-val">{{ contract.bnbStyleRent.totalNights }}</span></div>
                  <div class="crs-info-row" v-if="contract.bnbStyleRent!=null&&contract.bnbStyleRent.active"><span class="crs-info-key"><i class="fas fa-users mr-50"></i> {{ msg("Guests") }}</span><span class="crs-info-val">{{ contract.numberOfGuests }}</span></div>
                  <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-money-check-alt mr-50"></i> {{ msg("Platform commision") }}</span><span class="crs-info-val">{{ contract.bnbStyleRent.commissionAmount }} &euro;</span></div>
                  <div class="crs-info-row"><span class="crs-info-key"><i class="fa-solid fa-money-bill-transfer mr-50"></i> {{ msg("Payment Processing Fee") }}</span><span class="crs-info-val">{{ contract.bnbStyleRent.paymentProcessingFee }} &euro;</span></div>
                  <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-calendar-day mr-50"></i> {{ msg("Move Date") }}</span><span class="crs-info-val"><calendar-picker disabled v-model="contract.moveDate"/></span></div>
                  <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-calendar-day mr-50"></i> {{ msg("CheckOut") }}</span><span class="crs-info-val"><calendar-picker disabled v-model="contract.endDate"/></span></div>
                </div>
              </div>
            </b-tab>

            <!-- Client Tab -->
            <b-tab :title="msg('Client')">
              <div v-if="contract != null" class="crs-tab-content">
                <app-collapse accordion type="margin">
                  <app-collapse-item :title="msg('Profile - Client details for the contract')" is-visible>
                    <div class="crs-info-table">
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-tag mr-50"></i> Id</span><span class="crs-info-val">{{ client.id }} <b-button size="sm" variant="link" @click="openClientAccount"><i class="fa-solid fa-right-to-bracket"></i></b-button></span></div>
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-calendar-day mr-50"></i> {{ msg("Register date") }}</span><span class="crs-info-val">{{ client.creationTime }}</span></div>
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-user mr-50"></i> {{ msg("Firstname") }}</span><span class="crs-info-val text-capitalize">{{ contract.client.firstname }}</span></div>
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-user mr-50"></i> {{ msg("Lastname") }}</span><span class="crs-info-val text-capitalize">{{ contract.client.lastname }}</span></div>
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-birthday-cake mr-50"></i> {{ msg("Birthday") }}</span><span class="crs-info-val"><span v-if="contract.client.birthday != null && contract.client.birthday.trim() !== '' && contract.client.birthday !== '1970-01-01'">{{ contract.client.birthday | moment('DD/MM/YY') }}</span></span></div>
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-at mr-50"></i> {{ msg("Contract Email") }}</span><span class="crs-info-val">{{ contract.client.email }}</span></div>
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-at mr-50"></i> {{ msg("Client Email") }}</span><span class="crs-info-val" style="font-size:12px">{{ client.email }}</span></div>
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-phone-alt mr-50"></i> {{ msg("Phone") }}</span><span class="crs-info-val">{{ client.phone }}</span></div>
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-university mr-50"></i> {{ msg("address") }}</span><span class="crs-info-val">{{ contract.client.address.street }}</span></div>
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-university mr-50"></i> {{ msg("city") }}</span><span class="crs-info-val">{{ contract.client.address.city }}</span></div>
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-university mr-50"></i> {{ msg("Zip") }}</span><span class="crs-info-val">{{ contract.client.address.zip }}</span></div>
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-university mr-50"></i> {{ msg("country") }}</span><span class="crs-info-val">{{ contract.client.address.country }}</span></div>
                    </div>
                  </app-collapse-item>
                  <app-collapse-item title="Job">
                    <div class="crs-info-table">
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-suitcase mr-50"></i> {{ msg("Job Title") }}</span><span class="crs-info-val">{{ contract.income.jobTitle }}</span></div>
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-university mr-50"></i> {{ msg("Company") }}</span><span class="crs-info-val">{{ contract.income.companyName }}</span></div>
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-university mr-50"></i> {{ msg("Company street") }}</span><span class="crs-info-val">{{ contract.income.companyAddress.street }}</span></div>
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-university mr-50"></i> {{ msg("Company city") }}</span><span class="crs-info-val">{{ contract.income.companyAddress.city }}</span></div>
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-university mr-50"></i> {{ msg("Company country") }}</span><span class="crs-info-val">{{ contract.income.companyAddress.country }}</span></div>
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-file-invoice mr-50"></i> {{ msg("Netto income") }}</span><span class="crs-info-val">{{ contract.income.net }}</span></div>
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-user-clock mr-50"></i> {{ msg("Seniority") }}</span><span class="crs-info-val">{{ contract.income.seniority }}</span></div>
                    </div>
                  </app-collapse-item>
                  <app-collapse-item v-if="contract.card!=null" title="Card">
                    <div class="crs-info-table">
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-credit-card mr-50"></i> {{ msg("Name") }}</span><span class="crs-info-val">{{ contract.card.name }}</span></div>
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-hashtag mr-50"></i> {{ msg("Number") }}</span><span class="crs-info-val">{{ contract.card.number }}</span></div>
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-calendar mr-50"></i> {{ msg("Date") }}</span><span class="crs-info-val">{{ contract.card.date }}</span></div>
                      <div class="crs-info-row"><span class="crs-info-key"><i class="fas fa-lock mr-50"></i> {{ msg("Cvv") }}</span><span class="crs-info-val">{{ contract.card.cvv }}</span></div>
                    </div>
                  </app-collapse-item>
                </app-collapse>
              </div>
            </b-tab>

            <!-- Chat Tab -->
            <b-tab :title="msg('Chat')">
              <div v-if="contract != null" class="crs-tab-content">
                <hostaway-chat-component v-bind:contractId="contractId" v-bind:reservation-id="contract.hostawayReservationId" full-height :contract="contract"/>
              </div>
            </b-tab>

            <!-- Payments Tab -->
            <b-tab :title="msg('Payments')">
              <div v-if="contract!=null" class="crs-tab-content">
                <div class="d-flex justify-content-end mb-2">
                  <b-button variant="warning" size="sm" class="crs-btn" @click="openPaymentModal"><i class="fas fa-credit-card mr-50"></i> {{ msg('Make payment') }}</b-button>
                </div>
                <payment-client-table @submitted="reloadContractToPayment" :payments="contract.clientPayments" :contract-id="contract.id"/>
              </div>
            </b-tab>

            <!-- Damages Tab -->
            <b-tab :title="msg('Damages')">
              <div v-if="contract != null" class="crs-tab-content">
                <contract-damage-component v-bind:contract-id="contract.id"/>
              </div>
            </b-tab>
          </b-tabs>
        </div>

        <!-- Loading State -->
        <div v-else>
          <b-tabs v-model="tabsIndex" align="center" nav-class="crs-tabs-nav">
            <b-tab :title="msg('Contract')" active></b-tab>
            <b-tab :title="msg('Client')"></b-tab>
            <b-tab :title="msg('Chat')"></b-tab>
            <b-tab :title="msg('Payments')"></b-tab>
            <b-tab :title="msg('Damages')"></b-tab>
          </b-tabs>
          <div class="p-2">
            <b-skeleton-table :rows="15" :columns="2"></b-skeleton-table>
          </div>
        </div>
      </b-sidebar>
    </portal>

    <!-- Payment Modal -->
    <b-modal v-if="contract != null" no-fade v-model="dialogs.payment" size="l" ref="payment-modal" id="payment-modal" :hide-footer="true" :title="'Customer: ' + contract.client.lastname + ' ' + contract.client.firstname + ' - Stripe Payment'" no-close-on-backdrop centered>
      <div class="mt-2 text-center">
        <label class="crs-label">{{ msg("Type") }}</label>
        <v-select v-model="paymentType" class="mb-2" :clearable="false" :options="paymentOptions" label="label" :reduce="(b) => b.value" placeholder="Select payment type"></v-select>
        <div v-if="paymentType === 'Credit card'">
          <label class="crs-label">{{ msg("Reason") }}</label>
          <b-form-input v-model="reason" class="mb-2"></b-form-input>
          <label class="crs-label">{{ msg("Amount") }}</label>
          <b-form-input v-model="paymentAmount" type="number" step="0.01" min="0" max="3000" class="mb-2"></b-form-input>
          <b-button :disabled="paymentAmount == null || paymentAmount <= 0.0 || paymentLoading || reason == null" variant="success" class="crs-btn" @click="makePayment"><i class="fas fa-bolt mr-50"></i> {{ msg('Charge the customer now') }}</b-button>
        </div>
        <div v-else-if="paymentType === 'Cash' || paymentType === 'Wire transfer'">
          <label class="crs-label">{{ msg("Reason") }}</label>
          <b-form-input v-model="reason" class="mb-2"></b-form-input>
          <label class="crs-label">{{ msg("Amount") }}</label>
          <b-form-input v-model="paymentAmount" type="number" step="0.01" min="0" class="mb-2"></b-form-input>
          <b-form-checkbox class="mb-2" v-model="isPaid" switch>{{ isPaid ? msg("Paid") : msg("Not paid") }}</b-form-checkbox>
          <b-form-datepicker v-model="paymentDate" :min="minDate" placeholder="Select date" class="mb-2"></b-form-datepicker>
          <b-button :disabled="!paymentDate || paymentAmount == null || paymentAmount <= 0.0 || paymentLoading || reason == null" variant="success" class="crs-btn" @click="makePayment"><i class="fas fa-check mr-50"></i> {{ msg('Confirm Payment') }}</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import HostawayChatComponent from "@/views/realEstate/contracts/HostawayChatComponent.vue";
import PaymentClientTable from "@/views/realEstate/contracts/paymentClientTable.vue";
import ContractDamageComponent from "@/views/realEstate/contracts/ContractDamageComponent.vue";

export default {
  name: "ContractRentSidebar",
  components: {ContractDamageComponent, PaymentClientTable, HostawayChatComponent, AppCollapse, AppCollapseItem},
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) { this.getContract(); }
      }
    },
    'sidebar.visible'() {
      if (this.isBodyScrollDisabled !== this.sidebar.visible) {
        this.DISABLE_BODY_SCROLL(this.sidebar.visible);
      }
    }
  },
  data: () => ({
    loading: null,
    sidebar: { visible: false },
    dialogs: {sms: false, payment: false},
    tabsIndex: 0,
    contractId: null,
    contract: null,
    property: null,
    client: null,
    permissions: null,
    paymentAmount: 0.0,
    reason: null,
    paymentLoading: false,
    paymentType: null,
    isPaid: false,
    paymentDate: null,
  }),
  computed: {
    ...mapGetters("appConfig", ["isBodyScrollDisabled"]),
    minDate() { return new Date().toISOString().split('T')[0]; },
    paymentOptions() {
      return [
        {label: this.msg('Credit Card'), value: 'Credit card'},
        {label: this.msg('Cash'), value: 'Cash'},
        {label: this.msg('Wire Transfer'), value: 'Wire transfer'}
      ];
    },
  },
  methods: {
    ...mapActions("realEstateContracts", ["createPdfInvoiceContract", "getById", "updateContract", "sproofRequest", "cancelContract", "changeContract", "updateStatus", "updateFilesData", "updateApproveStatus", "changeContractOwner", "updateEditableFields", "updateDocumentFile", "generateAndSendLink", "sendCheckInDetails", "getMonetaryId"]),
    ...mapActions("clients", ["generateToken"]),
    ...mapMutations('appConfig', ['DISABLE_BODY_SCROLL']),
    ...mapActions("monetary", ["chargeCustomer"]),
    makePayment() {
      let $this = this;
      this.paymentLoading = true
      this.chargeCustomer({contractId: this.contract.id, amount: this.paymentAmount, reason: this.reason, type: this.paymentType, paid: this.isPaid, date: this.paymentDate}).then(approve => {
        $this.dialogs.payment = false
      }).finally(() => {
        $this.paymentLoading = false; $this.paymentAmount = 0.0; $this.reason = null; $this.paymentType = null; $this.isPaid = false; $this.paymentDate = null; $this.dialogs.payment = false; $this.reloadContractToPayment();
      })
    },
    openPaymentModal() { this.dialogs.payment = true },
    reloadContractToPayment() {
      this.sidebar.visible = false;
      this.sidebar.visible = true;
      this.tabsIndex = 3;
      this.getContract();
    },
    showContract(contractId) {
      this.contractId = contractId;
      this.sidebar.visible = true;
      this.tabsIndex = 0;
      this.getContract();
    },
    getContract() {
      if (this.contractId == null || this.contractId === "") return;
      let $this = this;
      let contractId = this.contractId;
      this.loading = contractId;
      this.getById(this.contractId).then(this.onContractReceive, this.onContractRetrieveError).finally(() => { if ($this.loading === contractId) { $this.loading = null } });
    },
    onContractReceive(data) {
      let $this = this;
      this.contract = data.contract;
      this.contract.statusHistories = this.contract.statusHistories.sort((a, b) => $this.$moment(b.time, 'YYYY-MM-DD HH:mm:ss').diff($this.$moment(a.time, 'YYYY-MM-DD HH:mm:ss')))
      this.property = data.property;
      this.client = data.client;
      this.permissions = data.permissions;
      this.allContractStatus = data.statuses;
    },
    openClientAccount() {
      this.generateToken(this.client.id).then(res => { window.open(res.details.sitePath, '_blank'); })
    }
  }
}
</script>

<style scoped>
.crs-header { display: flex; align-items: center; justify-content: space-between; padding: 16px 20px; border-bottom: 1px solid rgba(0,0,0,.06); }
.crs-header-icon { width: 38px; height: 38px; border-radius: 12px; display: flex; align-items: center; justify-content: center; background: rgba(115,103,240,.12); color: #7367f0; font-size: 16px; flex-shrink: 0; }
.crs-header-title { font-weight: 900; font-size: 15px; }
.crs-header-sub { font-size: 12px; opacity: .6; }
.crs-link-btn { width: 32px; height: 32px; border-radius: 10px; display: inline-flex; align-items: center; justify-content: center; background: rgba(115,103,240,.08); color: #7367f0; transition: all .12s; font-size: 13px; }
.crs-link-btn:hover { background: rgba(115,103,240,.15); transform: translateY(-1px); }
.crs-close-btn { width: 32px; height: 32px; border-radius: 10px; display: inline-flex; align-items: center; justify-content: center; padding: 0; }
.crs-body { padding: 0; }
.crs-tab-content { padding: 16px 20px; }
.crs-info-table { display: flex; flex-direction: column; }
.crs-info-row { display: flex; align-items: center; padding: 8px 0; border-bottom: 1px solid rgba(0,0,0,.04); }
.crs-info-row:last-child { border-bottom: none; }
.crs-info-key { font-size: 12px; font-weight: 700; opacity: .7; white-space: nowrap; min-width: 160px; flex-shrink: 0; }
.crs-info-val { font-size: 13px; flex: 1; min-width: 0; }
.crs-btn { border-radius: 12px; font-weight: 700; font-size: 12px; }
.crs-label { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .4px; opacity: .65; display: block; margin-bottom: 4px; }
</style>
